import { Col, Row, Image } from "antd";
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from "react-icons/fa6";
import p2 from "../../assets/p2.webp";

// import AboutUsHome from "../../views/homepage/aboutUsHome";

const UpcomingEvents = () => {
  const navigate = useNavigate();

  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <Row style={{ width: "100%", justifyContent: "center" }}>
            <Col lg={24}>
              <div class="arrow-box">
                <FaArrowLeftLong
                  className="arrow"
                  onClick={() => navigate(-1)}
                />
                <h3 className="main-heading">About Us</h3>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <section className="experience-fly ant-experience-fly">
      <div className="ant-container-fluid">
        <Row justify="center" gutter={16}>
          <Col lg={20} md={20} xs={23}>
            <Row align="middle" gutter={16}>
              <Col lg={13}>
                <h2 className="black-n-red-100">Car Travel <span>Specialists</span> </h2>
                <p className="web-p pb-3">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the when an unknown printer
                  took a galley of type and scrambled it to make a type specimen
                  book.
                  <br />
                  <br />
                  It has survived not only five centuries, but also the leap
                  into electronic typesetting, remaining essentially unchanged.
                  It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with
                  desktop publishing software like Aldus PageMaker including
                  versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of
                  the printing and typesetting industry.
                </p>
                {/* <Link to={"/aboutUs"} className="web-btn ant-web-btn">
                  Read More
                </Link> */}
              </Col>
              <Col lg={11}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={p2}
                    className=""
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </section>

      {/* <AboutUsHome /> */}
    </div>
  );
};

export default UpcomingEvents;
